export const COVER_IMAGE_PICTURE_ICON_ALT = 'cover-image.picture-icon-alt';
export const COVER_IMAGE_PHOTO_ALT = 'cover-image.picture-icon-alt';
